import { render, staticRenderFns } from "./FormaTraka.vue?vue&type=template&id=002651b7"
import script from "./FormaTraka.vue?vue&type=script&lang=js"
export * from "./FormaTraka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports